export function getScenarios(state) {
    return state.items;
}
export function getSelectedScenario(state) {
    return state.selected;
}
export function getSelectedScenarioName(state) {
    return state.selected;
}
export function getSelectedWorkspaceName(_state) {
    return "default";
}
export function getColor(state) {
    let i, j;
    for (i = 0; i < state.items.length; i++) {
        let scenario = state.items[i];
        if (scenario.name == state.scenarioName) {
            for (j = 0; j < scenario.workspaces.length; j++) {
                let workspace = scenario.workspaces[j];
                if (workspace.name == state.workspaceName) {
                    return workspace.color;
                }
            }
        }
    }
}
export function isFetching(state) {
    return state.fetching;
}
//# sourceMappingURL=selectors.js.map